import React from "react";
import { FaLinkedin, FaEnvelope } from "react-icons/fa";
import "./OurTeamabout.css";
import asifalikhan from "../../assets/images/asif11.jpg";

export default function OurTeamabout() {
  return (
    <section className="our-team-section">
      <div className="container">
        <h2 className="heading">Meet Our Visionary Leader</h2>
        <p className="subheading">
          Leading with innovation and expertise in industrial and statutory consulting.
        </p>

        <div className="team-card">
          {/* Big Image on Left Side */}
          <div className="team-image-container">
            <img src={asifalikhan} alt="Asif Ali Khan" className="team-photo" />
          </div>

          {/* Info on Right Side */}
          <div className="team-info">
            <h3 className="team-name">Asif Ali Khan</h3>
            <p className="team-title">Founder & Managing Director</p>
            <p className="team-description">
              A seasoned expert in industrial and statutory consulting, he has a
              remarkable track record in regulatory compliance, licensing, and business
              facilitation. His leadership ensures seamless execution of statutory processes,
              empowering businesses to grow efficiently.
            </p>

            <div className="team-contact">
              <a
                href="https://linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
                className="team-link"
              >
                <FaLinkedin className="team-icon" /> LinkedIn
              </a>
              <a href="mailto:director@saarsindia.com" className="team-link">
                <FaEnvelope className="team-icon" /> Email
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
